import React, {useState} from "react"
import {createUseStyles, useTheme} from "react-jss"
import {GlobalToken} from "antd/es/theme/interface"
import LeftArrowButton from "../../components/buttons/LeftArrowButton";
import {useGetPrintsQuery} from "../../store/api/printApiV2";
import {useGetSelfEmployeeQuery} from "../../store/api/employeeApi";
import {Alert, Button, Space} from "antd";
import {ERROR, PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_SIZE} from "../../types/utils/Constants";
import {useNavigate} from "react-router-dom";
import PrintCard from "../../features/print/PrintCard";

const useStyles = createUseStyles<string, { active: boolean }, GlobalToken>(theme => ({
    menuDrawer: {
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 999,
        pointerEvents: (props) => props.active ? "inherit" : "none"
    },
    bg: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 998,
        background: "rgba(0, 0, 0, .2)",
        backdropFilter: "blur(4px)",
        opacity: (props) => props.active ? 1 : 0,
        transition: "all .15s ease"
    },
    menuListBlock: {
        position: "absolute",
        right: (props) => props.active ? 0 : "-100%",
        top: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        background: "#fff",
        width: "max-content",
        padding: "15px 15px 15px 45px",
        boxShadow: "12px 0px 47px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px 0 0 20px",
        zIndex: 999,
        transition: "all .15s ease",
        transform: "translateX(0)"
    },
    listItem: {
        padding: "15px 0",
        width: "100%",
        fontWeight: 400,
        fontSize: theme.fontSize,
        lineHeight: "20px",
        cursor: "pointer",
        color: "#1E1E1E",
        borderBottom: "1px solid rgba(181, 181, 181, .3)",
        transition: "all .15s ease",
        "&:hover": {
            padding: "20px 0",
            fontSize: theme.fontSize,
            color: theme.colorPrimary
        }
    },
    menuLogo: {
        height: "38.11px",
        width: "156.79px",
        cursor: "pointer",
        "& img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            verticalAlign: "top"
        }
    },
    wrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "15px",
        borderBottom: "1px solid rgba(181, 181, 181, .3)",
        padding: "25px 0",
        marginBottom: "10px"
    },
    closeNavBtn: {
        width: "64px",
        height: "27px",
        background: "#fff",
        borderRadius: "20px",
        border: "1px solid #145839",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    scroll: {
        overflowY: 'auto',
        paddingTop: 10,
        paddingBottom: 10
    },
    topButton: {
        width: '100%'
    }
}))


interface DrawerMenuProps {
    active: boolean
    onClose: () => void,
    printTypes: string[] | undefined,
    changeSection: () => void
}

const HeaderRightDrawer: React.FC<DrawerMenuProps> = ({active, onClose, printTypes, changeSection}) => {
    const navigate = useNavigate()
    const theme = useTheme<GlobalToken>()
    const classes = useStyles({theme, active: active})
    const [checkedItems] = useState<number[]>([])

    const {data: employee} = useGetSelfEmployeeQuery()



    const {data: prints} = useGetPrintsQuery(
        {
            account_id: employee?.data?.account?.id,
            types: printTypes,
            page: PAGINATION_DEFAULT_PAGE,
            size: PAGINATION_DEFAULT_SIZE
        },
        {skip: !employee?.data?.account}
    )

    const seeAllButtonHandler = () => {
        navigate('/')
        changeSection()
        onClose()
    }

    const onCardClicked = (id: number, isInsertion: boolean) => {
        if (isInsertion) {
            checkedItems.push(id)
        } else
            checkedItems.splice(checkedItems.indexOf(id), 1)
    }

    return (
        <div className={classes.menuDrawer}>
            <div onClick={() => onClose()} className={classes.bg}/>
            <div className={classes.menuListBlock}>
                <div className={classes.wrapper}>
                    <LeftArrowButton onClick={onClose}/>
                    {
                        // @ts-ignore
                        <Alert showIcon type={printTypes?.at(0)}
                               message={(printTypes?.at(0) === ERROR ? 'Просроченные ' : 'Истекающие ') + 'распечатка'}/>
                    }
                </div>
                <Space direction='vertical' className={classes.scroll}>
                    <Button onClick={seeAllButtonHandler} size={"large"} type={'primary'} className={classes.topButton}>
                        Смотреть все
                    </Button>
                    {
                        prints
                            ?.data
                            ?.content
                            ?.map(item => <PrintCard key={item.id} item={item} checkedItems={checkedItems} onClickAction={onCardClicked}/>)
                    }
                </Space>
            </div>
        </div>
    )
}

export default HeaderRightDrawer
